'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _OMCheckboxDropdown = require('./OMCheckboxDropdown.scss');var _OMCheckboxDropdown2 = _interopRequireDefault(_OMCheckboxDropdown);
var _isSameElement = require('../../../helpers/isSameElement');var _isSameElement2 = _interopRequireDefault(_isSameElement);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

OMCheckboxDropdown = function (_Component) {_inherits(OMCheckboxDropdown, _Component);
  function OMCheckboxDropdown(props) {_classCallCheck(this, OMCheckboxDropdown);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_initialiseProps.call(_this);
    _this.state = {
      isOpen: false,
      pristine: _this.checkPristine(props) };return _this;

  }OMCheckboxDropdown.prototype.

  componentDidMount = function componentDidMount() {
    document.body.addEventListener('click', this.bodyClickHandler);
  };OMCheckboxDropdown.prototype.

  componentWillReceiveProps = function componentWillReceiveProps(_ref) {var value = _ref.value;
    if (this.state.pristine && !this.props.value.length && value.length && value[0] !== 'all') {
      this.setState({ pristine: false });
    }
  };OMCheckboxDropdown.prototype.

  componentWillUnmount = function componentWillUnmount() {
    document.body.removeEventListener('click', this.bodyClickHandler);
  };OMCheckboxDropdown.prototype.






































  render = function render() {var _this2 = this,_cx,_cx2;var _props =
    this.props,options = _props.options,value = _props.value,title = _props.title,className = _props.className,width = _props.width,counterSelected = _props.counterSelected,counterGeneral = _props.counterGeneral;
    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(_OMCheckboxDropdown2.default.wrapper, _OMCheckboxDropdown2.default[className]),
          ref: function ref(node) {_this2.node = node;},
          style: { width: width + 'px' } },

        _react2.default.createElement('button', {
            className: this.props.items ?
            _OMCheckboxDropdown2.default.columnsButton :
            (0, _classnames2.default)(_OMCheckboxDropdown2.default.button, (_cx = {}, _cx[_OMCheckboxDropdown2.default.isOpen] = this.state.isOpen, _cx)),
            onClick: this.handleOpen },

          this.props.items ?
          _react2.default.createElement('div', { className: _OMCheckboxDropdown2.default.titleContainer },
            _react2.default.createElement('span', { className: _OMCheckboxDropdown2.default.iconBlock }, _react2.default.createElement('i', { className: 'icon icon-setting-gears' })),
            _react2.default.createElement('span', { className: _OMCheckboxDropdown2.default.columnsTitle },
              title + ': ',
              _react2.default.createElement('span', { className: _OMCheckboxDropdown2.default.counterSelected }, counterSelected), '/' +
              counterGeneral)) :


          _react2.default.createElement('div', null,
            _react2.default.createElement('span', { className: (0, _classnames2.default)(_OMCheckboxDropdown2.default.title, (_cx2 = {}, _cx2[_OMCheckboxDropdown2.default.pristine] = this.state.pristine, _cx2)) }, title),
            _react2.default.createElement('span', { className: (0, _classnames2.default)(_OMCheckboxDropdown2.default.arrow, _OMCheckboxDropdown2.default['caret-' + (this.state.isOpen ? 'up' : 'down')]) }))),


        this.state.isOpen ?
        _react2.default.createElement('ul', { className: this.props.items ? _OMCheckboxDropdown2.default.columnSelect : _OMCheckboxDropdown2.default.select },
          options.map(function (el) {var _cx3;return (
              _react2.default.createElement('li', {
                  key: el.value,
                  className: _this2.props.items ?
                  (0, _classnames2.default)(_OMCheckboxDropdown2.default.columnsOption) :
                  (0, _classnames2.default)(_OMCheckboxDropdown2.default.option, (_cx3 = {}, _cx3[_OMCheckboxDropdown2.default.selected] = value.indexOf(el.value) !== -1, _cx3)) },

                _react2.default.createElement('input', {
                  id: el.value,
                  'data-title': el.value,
                  type: 'checkbox',
                  className: _OMCheckboxDropdown2.default.checkbox,
                  value: el.value,
                  checked: value.indexOf(el.value) !== -1,
                  readOnly: true,
                  disabled: _this2.isDisabled(el.value),
                  onClick: _this2.handleOptionClick }),

                _react2.default.createElement('label', {
                    htmlFor: el.value },

                  el.label)));})) :



        null));


  };return OMCheckboxDropdown;}(_react.Component);var _initialiseProps = function _initialiseProps() {var _this3 = this;this.bodyClickHandler = function (evt) {if (!_this3.state.isOpen) {return;}if (!(0, _isSameElement2.default)(_this3.node, evt.target)) {_this3.setState({ isOpen: false });}};this.handleOpen = function (evt) {evt.preventDefault(); // needs for mobile filters
    _this3.setState({ isOpen: !_this3.state.isOpen }, function () {return _this3.props.onOpen && _this3.props.onOpen(evt);});};this.handleOptionClick = function (evt) {var dataTitle = evt.target.dataset.title;var result = +dataTitle ? +dataTitle : dataTitle;var stateModifier = {};if (_this3.state.pristine) {stateModifier.pristine = false;}_this3.props.onChange(result);if (_this3.props.shouldCloseOnClick) {stateModifier.isOpen = false;}_this3.setState(stateModifier);};this.isDisabled = function (value) {return _this3.props.items ? (0, _get2.default)(_this3.props.items.find(function (v) {return v.name === value;}), 'disabled', false) : false;};this.checkPristine = function (props) {return props.value && (!props.value.length || props.value[0] === 'all');};};exports.default = OMCheckboxDropdown;

OMCheckboxDropdown.propTypes = {
  options: _propTypes2.default.array,
  title: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onOpen: _propTypes2.default.func,
  value: _propTypes2.default.oneOfType([
  _propTypes2.default.string,
  _propTypes2.default.array]),

  items: _propTypes2.default.array,
  className: _propTypes2.default.string,
  shouldCloseOnClick: _propTypes2.default.bool,
  width: _propTypes2.default.number,
  counterSelected: _propTypes2.default.number,
  counterGeneral: _propTypes2.default.number };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMCheckboxDropdown/OMCheckboxDropdown.js
// module id = 561
// module chunks = 0